import s from "react";
import I from "../../../../_virtual/isFunction.js";
import { clsx as D } from "../../../clsx/dist/clsx.js";
import { Layer as T } from "../container/Layer.js";
import { Label as M } from "../component/Label.js";
import { createLabeledScales as V, rectWithPoints as B } from "../util/CartesianUtils.js";
import { ifOverflowMatches as S } from "../util/IfOverflowMatches.js";
import { isNumOrStr as y } from "../util/DataUtils.js";
import { warn as L } from "../util/LogUtils.js";
import { Rectangle as F } from "../shape/Rectangle.js";
import { filterProps as K } from "../util/ReactUtils.js";
function w() {
  return w = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, w.apply(this, arguments);
}
function c(t) {
  "@babel/helpers - typeof";
  return c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, c(t);
}
function j(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function R(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? j(Object(r), !0).forEach(function(n) {
      b(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : j(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function W(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function X(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, A(n.key), n);
  }
}
function Y(t, e, r) {
  return e && X(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function z(t, e, r) {
  return e = m(e), $(t, E() ? Reflect.construct(e, r || [], m(t).constructor) : e.apply(t, r));
}
function $(t, e) {
  if (e && (c(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return k(t);
}
function k(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function E() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (E = function() {
    return !!t;
  })();
}
function m(t) {
  return m = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, m(t);
}
function q(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && x(t, e);
}
function x(t, e) {
  return x = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, x(t, e);
}
function b(t, e, r) {
  return e = A(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function A(t) {
  var e = G(t, "string");
  return c(e) == "symbol" ? e : e + "";
}
function G(t, e) {
  if (c(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (c(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var H = function(e, r, n, a, i) {
  var h = i.x1, d = i.x2, v = i.y1, O = i.y2, p = i.xAxis, f = i.yAxis;
  if (!p || !f) return null;
  var o = V({
    x: p.scale,
    y: f.scale
  }), u = {
    x: e ? o.x.apply(h, {
      position: "start"
    }) : o.x.rangeMin,
    y: n ? o.y.apply(v, {
      position: "start"
    }) : o.y.rangeMin
  }, l = {
    x: r ? o.x.apply(d, {
      position: "end"
    }) : o.x.rangeMax,
    y: a ? o.y.apply(O, {
      position: "end"
    }) : o.y.rangeMax
  };
  return S(i, "discard") && (!o.isInRange(u) || !o.isInRange(l)) ? null : B(u, l);
}, _ = /* @__PURE__ */ function(t) {
  function e() {
    return W(this, e), z(this, e, arguments);
  }
  return q(e, t), Y(e, [{
    key: "render",
    value: function() {
      var n = this.props, a = n.x1, i = n.x2, h = n.y1, d = n.y2, v = n.className, O = n.alwaysShow, p = n.clipPathId;
      L(O === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      var f = y(a), o = y(i), u = y(h), l = y(d), P = this.props.shape;
      if (!f && !o && !u && !l && !P)
        return null;
      var g = H(f, o, u, l, this.props);
      if (!g && !P)
        return null;
      var N = S(this.props, "hidden") ? "url(#".concat(p, ")") : void 0;
      return /* @__PURE__ */ s.createElement(T, {
        className: D("recharts-reference-area", v)
      }, e.renderRect(P, R(R({
        clipPath: N
      }, K(this.props, !0)), g)), M.renderCallByParent(this.props, g));
    }
  }]);
}(s.Component);
b(_, "displayName", "ReferenceArea");
b(_, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#ccc",
  fillOpacity: 0.5,
  stroke: "none",
  strokeWidth: 1
});
b(_, "renderRect", function(t, e) {
  var r;
  return /* @__PURE__ */ s.isValidElement(t) ? r = /* @__PURE__ */ s.cloneElement(t, e) : I(t) ? r = t(e) : r = /* @__PURE__ */ s.createElement(F, w({}, e, {
    className: "recharts-reference-area-rect"
  })), r;
});
export {
  _ as ReferenceArea
};
